import router from '../router/index.js'//路由



const wxPay = function(params){  
	function onBridgeReady(){
	   WeixinJSBridge.invoke(
		  'getBrandWCPayRequest', {
			 "appId":params.appId,     //公众号ID，由商户传入     
			 "timeStamp":params.timeStamp,         //时间戳，自1970年以来的秒数     
			 "nonceStr":params.nonceStr, //随机串     
			 "package":params.package,     
			 "signType":"MD5",         //微信签名方式：     
			 "paySign":params.paySign //微信签名 
		  },
			function(res){	
				  if(res.err_msg == "get_brand_wcpay_request:ok" ){
				  // 使用以上方式判断前端返回,微信团队郑重提示：
						router.replace({
							path:'/orderList',
							query:{
								name:'待提货'
							}	
						})
				  } 
				  else{					  
					  if(router.history.current.path!=='/orderList'){
						router.replace({
							path:'/orderList',
							query:{
								name:'待支付'
							}	
						})
					  }	
				  }
			}); 
	}
	if (typeof WeixinJSBridge == "undefined"){
	   if( document.addEventListener ){
		   document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
	   }else if (document.attachEvent){
		   document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
		   document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
	   }
	}else{
	   onBridgeReady();
	}
}

export default wxPay